'use client'
import { Grid as ChakraGrid, GridProps } from '@chakra-ui/react'
import { ReactNode } from 'react'

export interface CustomGridProps extends GridProps {
  children: ReactNode
}

/**
 * Represents a grid styled and spaced for bouwinvest
 * @param children - Able to render all elements within this custom grid
 * @returns Grid
 */
export const CustomGrid = ({ children, ...props }: CustomGridProps) => {
  return (
    <ChakraGrid
      templateColumns='repeat(12, 1fr)'
      margin='auto'
      gap={{ base: 6, lg: 9 }}
      py={{ base: 6, md: 9 }}
      px={{ base: 4, md: 9 }}
      as='section'
      {...props}
    >
      {children}
    </ChakraGrid>
  )
}
